import React from "react";

interface CompetitionTitleProps {
  title: string;
  onClick: (e: React.MouseEvent<HTMLImageElement>) => void;
}

const CompetitionTitle: React.FC<CompetitionTitleProps> = ({ title, onClick }) => {
  return (
    <div className="flex items-center gap-2 text-secondary lg:text-[#28282B] font-jost text-lg font-medium leading-6 lg:text-xl lg:leading-[26px]">
      {title}
      <img
        src="/assets/images/subscription-competitions/tabler-icon-info-circle-filled.svg"
        alt="info-icon"
        className="cursor-pointer size-5 shrink-0"
        onClick={onClick}
      />
    </div>
  );
};

export default CompetitionTitle;
